import React, { useState, useEffect } from 'react'

const Slideshow = ( { images = [], className = "slideshow-image", slideTimer = 5000, tint = 0, blur = 0, opacity = 1 } ) => {

    const [ imageIndex, setImageIndex ] = useState( 0 )

    const isImageActive = ( index ) => index === imageIndex


    const imageClass = ( index ) => isImageActive( index ) ? `${className} active-slide-image` : `${className} inactive-slide-image`

    useEffect( () => {
        const timer = setTimeout( () => {

            setImageIndex( images.length ? ( imageIndex + 1 )  % images.length : 0 )

        }, slideTimer )

        return () => clearTimeout( timer )
    }, [ images, imageIndex ] )

     
    return (
        <>
            
            {images && images.map( ( image, index ) => <div key={index} className={imageClass( index )} style={image && { backgroundImage : `url(${image})`, filter: `blur(${blur}em) opacity(${opacity})` }} /> )}
            {tint > 0 && <div className="slideshow-tint" style={{ opacity: tint }}/> }
        </>
    )
}

export default Slideshow